import { makeStyles, Theme } from '@material-ui/core';
import { THEME_MODES } from '../..';

interface StyleProps {
    popperMinWidth: number;
}

export const useThemeAonStyle = makeStyles((theme: Theme) => {
    return {
        icon: {
            display: 'flex',
            alignItems: 'center',
            width: 16,
            height: 16,
            color:
                theme.palette.type === THEME_MODES.DARK
                    ? theme.palette.secondary.contrastText
                    : theme.palette.secondary.main,
            opacity: 0.6,
        },
        checkedIcon: {
            width: 16,
            height: 16,
            color: theme.palette.info.main,
            opacity: 1,
        },
        expandMoreIcon: {
            color: theme.palette.secondary.contrastText,
        },
        tag: {
            color: 'white',
            fontSize: '1.2rem',
            margin: `${theme.spacing(0)}px ${theme.spacing(1)}px`,
        },
        mainOptionTitle: {
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
        },
    };
});

export const useThemeAutocompleteAonStyle = makeStyles(
    (theme: Theme) => {
        return {
            root: {
                height: 40,
                width: 280,
                '& fieldset': {
                    borderColor: `${theme.palette.secondary.contrastText}!important`,
                },
                '& .MuiFormLabel-root': {
                    color: theme.palette.secondary.contrastText,
                },
                '& .MuiInputLabel-outlined': {
                    transform: 'translate(14px, 12px) scale(1)',
                },
                '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -6px) scale(0.75)',
                },
            },
            inputRoot: {
                height: 40,
                paddingTop: '0!important',
                paddingBottom: '0!important',
            },
            input: {
                caretColor: theme.palette.secondary.contrastText,
                color: theme.palette.secondary.contrastText,
                '&::placeholder': {
                    color: theme.palette.secondary.contrastText,
                },
            },
            focused: {
                '& fieldset': {
                    borderColor: `${theme.palette.info.main}!important`,
                },
            },
            endAdornment: {
                top: 8,
            },
            paper: {
                paddingTop: '0!important',
                paddingBottom: '0!important',
                backgroundColor: theme.palette.primary.light,
            },
            listbox: {
                paddingTop: '0!important',
                paddingBottom: '0!important',
            },
            option: {
                fontSize: '1.2rem',
                paddingTop: 0,
                paddingBottom: 0,
            },
            noOptions: {
                fontSize: '1.4rem',
            },
            popper: {
                minWidth: ({ popperMinWidth }: StyleProps) => popperMinWidth,
            },
        };
    },
    { index: 1 }
);
